import React from 'react';
import PaymentIframe from './payment-iframe';
import styles from './credit-card.module.scss';
import { IPaymentConnector } from '~/interfaces/payment';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import { Maybe, UsAePayErrorMessage } from '~/gql/__generated__/types';

interface CreditCardProps {
  acceptContent: IPaymentConnector;
  isForterValidationEnabled: boolean;
  cartId: string;
  orderDetails: ISalesOrderResponse;
  usaEPayErrorMessages?: Maybe<Maybe<UsAePayErrorMessage>[]> | undefined;
  isForterValidationEnabledForAdyen?: boolean;
}

const Adyen: React.FC<CreditCardProps> = ({
  acceptContent,
  isForterValidationEnabled,
  cartId,
  orderDetails,
  usaEPayErrorMessages,
  isForterValidationEnabledForAdyen,
}) => {
  return (
    <div className={`${styles.section} ${styles.adyenSection}`}>
      <PaymentIframe
        iframeAriaLabel="Payment iframe"
        displayContent={acceptContent.connectorHtml.AcceptPageContent}
        sourceUrl={acceptContent.connectorHtml.AcceptPageUrl}
        messageOrigin={acceptContent.connectorHtml.MessageOrigin}
        paymentType={acceptContent.tenderType}
        isForterValidationEnabled={isForterValidationEnabled}
        cartId={cartId}
        orderDetails={orderDetails}
        usaEPayErrorMessages={usaEPayErrorMessages}
        isForterValidationEnabledForAdyen={isForterValidationEnabledForAdyen}
      />
    </div>
  );
};

export default Adyen;
